
export default function Sidebar(){
    
    const username=localStorage.getItem("username");
    const role=localStorage.getItem("role");

    return(<>
    <div className="container-fluid">
        <div className="heading">
            <h3>Hi {username || "Unknown"}!</h3>
            <hr />
        </div> 
        <div className="nav-list">
            <ul>
                <li><a href="/dashboard">Dashboard</a></li>
                {role==="Admin" && <>
                 <li><a href="/course">Course</a></li>
                <li><a href="/question">Question</a></li>
                <li><a href="/user">User</a></li>
                </>}
                {role==="User" && <>
                <li><a href="/candidate">Candidate</a></li>
                </>}
                <li><a href="/plan">plan</a></li>
                <li><a href="/profile">Profile</a></li>
                <li><a href="/">Logout</a></li>
            </ul>
        </div>    
    </div>
    </>);
}